import { PAGE_NAME } from "../../../const/analytics";
import { enrollmentType } from "../../../const/enrollmentConsts";
import triggerAnalytics from "../../../helpers/triggerAnalytics";
var analyticsHandler = function (_a) {
    var clientId = _a.clientId, product = _a.product, isStatementError = _a.isStatementError, noStatementsTitle = _a.noStatementsTitle, statementsEnrollmentType = _a.statementsEnrollmentType;
    var PAPER = enrollmentType.PAPER, ELECTRONIC = enrollmentType.ELECTRONIC, ELECTRONIC_AND_PAPER = enrollmentType.ELECTRONIC_AND_PAPER;
    if (isStatementError) {
        triggerAnalytics({
            clientName: clientId,
            product: product,
            errorMessage: noStatementsTitle,
            messageType: "api failed",
            pageName: PAGE_NAME.UNENROLLED_NO_STATEMENTS_API_FAIL,
            pageSubFunction: statementsEnrollmentType === PAPER ? "unenrolled" : "enrolled",
        });
        return;
    }
    // eslint-disable-next-line default-case
    switch (statementsEnrollmentType) {
        case PAPER:
            triggerAnalytics({
                clientName: clientId,
                product: product,
                messageType: "unenrolled no statements",
                message: noStatementsTitle,
                pageName: PAGE_NAME.NO_STATEMENTS,
                pageSubFunction: "unenrolled",
            });
            break;
        case ELECTRONIC:
        case ELECTRONIC_AND_PAPER:
            triggerAnalytics({
                clientName: clientId,
                product: product,
                messageType: "enrolled no statements",
                message: noStatementsTitle,
                pageName: PAGE_NAME.NO_STATEMENTS,
                pageSubFunction: "enrolled",
            });
    }
};
export default analyticsHandler;
